const postsDictionary = {
   getPosts:()=>"",
   addPost: () => "/posts",
}

export default postsDictionary;